<lib-form-container *ngIf="viewModel$ | async as viewModel">
    <h1>{{ viewModel.pageTitle }}</h1>

    <div class="markdown-content" [innerHTML]="viewModel.markdownAsHtml"></div>
</lib-form-container>
